import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../core/services/auth.service';

export interface CreateBookingRequest {
  unitId: string;
  paymentMethod: 'misr_card' | 'card' | 'wallet' | 'bank_transfer';
  name: string;
  email: string;
  mobileNumber: string;
  numberOfGuests: number;
  arrivalDate: string;
  departureDate: string;
  rentalType: 'daily' | 'weekly' | 'monthly' | 'yearly';
  currency: string;
  city: string;
  state: string;
  country: string;
}

@Injectable({ providedIn: 'root' })
export class BookingService {
  private readonly baseUrl = environment.api.baseUrl;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  createBooking(payload: CreateBookingRequest): Observable<unknown> {
    const token = this.authService.getAccessToken();
    const headers = token
      ? new HttpHeaders({ Authorization: `Bearer ${token}` })
      : new HttpHeaders();

    return this.http.post(`${this.baseUrl}/booking`, payload, { headers });
  }
}
